import React, { Component } from "react";

class ContactInfo extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__contact-address-area mb-90  ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/10.png"}
                    alt="IconImage"
                  />
                </div>
                <h5>Email Address</h5>
                <p>
                  <a href="mailto:Info@assignmentwriting.org">
                    Info@assignmentwriting.org
                  </a>
                  <br></br>
                  <a href="mailto:assignmentwriting@gmail.com">
                    assignmentwriting@gmail.com
                  </a>
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/11.png"}
                    alt="IconImage"
                  />
                </div>
                <div className="ltn__top-bar-menu ">
                  <h5>UK Call And whatsapp</h5>
                  <ul>
                    <li>
                      <a
                        href="https://wa.me/+44 7351212548?text=Referral%20link%20website%3A%20www.thesishelps.org"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{textAlign:"center"}}
                      >
                        +44 7351212548
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img
                    src={publicUrl + "assets/img/icons/11.png"}
                    alt="IconImage"
                  />
                </div>
                <div className="ltn__top-bar-menu ">
                  <h5>PAK Number</h5>
                  <ul>
                    <li>
                      <a
                        href="https://wa.me/+447351212548?text=Referral%20link%20website%3A%20www.thesishelps.org"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        +447351212548{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactInfo;
